import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class FilterIdsArraySearchValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new FilterIdsArraySearchValueObject({value: value.map(id => StringSharedValueObject.create({value: id}))})
  }

  static createWithSanitize({config, value}) {
    return new FilterIdsArraySearchValueObject({
      value: value.map(id => StringSharedValueObject.createWithSanitize({config, value: id}))
    })
  }

  static createForNumbers({value}) {
    return new FilterIdsArraySearchValueObject({value: value.map(id => NumberSharedValueObject.create({value: id}))})
  }

  get isEmpty() {
    return !this.#value.length
  }

  get value() {
    return this.#value.map(id => id?.value)
  }

  toJSON() {
    return {value: this.#value.map(id => id?.toJSON())}
  }
}
